<template>
  <div class="containerMod">
    <div v-if="loading" class="loading-container">
      <div class="loader"></div>
    </div>
    <div v-else>
      <div class="bloqueFicha" v-for="libro in libros" :key="libro._id">
        <div>
          <img class="portada" v-show="libro.portada" :src="libro.portada"/>
          <img class="portada" v-show="!(libro.portada)" src='@/assets/PortadaND.png'/>
        </div>
        <div class="contenido">
          <div class="linea1">
            {{libro.titulo}}
          </div>
          <div class="linea2">
            {{ libro.autores.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ') }}
          </div>
          <div class="linea3">
            {{libro.editorial}}
            {{libro.ciudad ? (' | ' + libro.ciudad) : `` }}
            {{libro.pais ? (' - ' + libro.pais) : `` }}
          </div>
          <div class="linea3">
            {{libro.edicion ? (libro.edicion + '&ordf;' + ' edición ') : `` }}
            {{libro.fecha}}
            {{libro.ISBN ? (' - ISBN ' + libro.ISBN) : `` }}
          </div>
          <div class="linea3">
            {{libro.numPaginas > 0 ? (libro.numPaginas + ' págs.') : `` }}
            {{libro.size ? (libro.size + 'mm') : ``}}
          </div>
          <div class="linea3">
            {{libro.papel ? 'Edición papel' : (libro.digital ? 'Edición digital' : ``)}}
            {{libro.papel ? (libro.digital ? ' | ' + 'Versión digital' : ``) : `` }}
            {{libro.idioma ? (' | ' + libro.idioma) : ``}}
          </div>
          <div class="linea4">
            <div class="lineaIndice">
              <p class="indice">Índice</p>
              <p class="up" @click="verIndice(libro._id)" v-show="!indicesVisibles.some(e => e === libro._id)">&dtrif;</p>
              <p class="down" v-show="indicesVisibles.some(e => e === libro._id)" @click="ocultarIndice(libro._id)">&utrif;</p>
            </div>
            <p v-show="indicesVisibles.some(e => e === libro._id)">{{libro.indice}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import XCerrarModal from './XCerrarModal.vue'
import axios from 'axios'
export default {
  // components: { XCerrarModal },
  name: 'ShowLibros',
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.getLibros()
  },
  data () {
    return {
      libros: [],
      librosPlus: [],
      autores: [],
      visible: false,
      indicesVisibles: [],
      desplegado: false,
      URLbase: '',
      loading: false
    }
  },
  methods: {
    cerrarModal: function () {
      this.$router.go(-1)
    },
    async getLibros () {
      try {
        this.loading = true
        const url = `${this.URLbase}/libros/getLibros`
        const res = await axios.get(url)
        this.libros = res.data
        this.loading = false
      } catch (error) {
        alert(error)
        this.loading = false
      }
    },
    verIndice (ID) {
      this.indicesVisibles.push(ID)
      this.desplegado = !this.desplegado
    },
    ocultarIndice (ID) {
      this.indicesVisibles = this.indicesVisibles.filter(e => e !== ID)
      this.desplegado = !this.desplegado
    }
  },
  computed: {
    librosProcesado () {
      // La idea es hacer un proceso donde el array de obetos 'libros' pase de tener como autores un array
      // con los id de los autores a un campo tipo string con los nombres de los autores. De momento se usa
      // lógica en el template para obtener los nombres de los autores a partir de sus códigos.
      return ''
    }
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.containerMod {
  overflow-y: auto;
  height: 99%;
  width: 100%;
  margin-top: 3px;
  background-color: var(--gr-fo-for);
  color:rgb(2, 2, 2);
}
.bloqueFicha{
  margin-top: 10px;
  padding-bottom: 1px;
  display: grid;
  grid-template-columns: 26% 70%;
}
.portada{
  width: 130px;
  box-shadow: rgb(87, 85, 85) 5px 5px 7px;
}
.portadaND{
  width: 120px;
  height: 170px;
  border: solid 0.5px rgb(63, 193, 253);
  border-radius: 5px;
}
.contenido{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 10px;
  border-bottom: solid 0.5px rgb(136, 166, 180);
  padding-bottom: 25px;
  margin-bottom: 0px;
}
.linea1{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: 17px;
  color: rgb(30, 119, 161);
}
.linea2{
  font-size: 14px;
  font-weight:800;
}
.linea3{
  font-size: 14px;
}
.linea4{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  white-space: pre-line;
  color:rgb(25, 25, 25)
}
.linea4 p{
  text-align: left;
}
.lineaIndice{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.indice{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  color: rgb(30, 119, 161);
  padding-top: 3px;
  margin-right: 3px;
}
.up, .down{
  cursor:pointer;
  font-size: 30px;
}
.selector, .retorno{
  color: rgb(2, 2, 2);
  font-size: 20px;
  font-weight: bolder;
  cursor: pointer;
  height: 16px;
  width: 16px;
  align-self: center;
  padding-bottom: 8px;
}
.loading-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loader {
  border: 4px solid transparent;
  border-top-color: #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin: auto;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
@media screen and (max-width: 576px){
 .containerMod{
  display: flex;
  flex-direction: column;
  align-items: center;
 }
 .bloqueFicha{
  display: flex;
  flex-direction: column;
  width: 90%
  }
  .portada{
    width: 230px;
    margin-top: 5px;
    margin-bottom: 15px;
  }
  .portadaND{
    width: 200px;
    margin-top: 5px;
    margin-bottom: 15px;
  }
  .linea1, .linea2, .linea3{
    text-align: left;
  }
  .linea2{
    margin:4px 0 4px;
  }
  .up, .down{
    margin:  2px 4px 0;
  }
}
</style>
